import {SteddiError} from "../types/Error";
import BrandEnum from "../types/BrandEnum";
import {AxiosError} from "axios";

export function parseEndpointError(err: AxiosError<any>) {
  if (err.response?.data?.detail !== undefined) {
    return (err.response.data as SteddiError)
  } else if (typeof err.response?.data === "string") {
    return {detail: err.response.data, status: 500,} as SteddiError
  } else {
    return {detail: "En ukjent feil har oppstått", status: 500,} as SteddiError
  }
}

export function getRedirectUrl(brand: BrandEnum): string {
  switch(brand) {
    case BrandEnum.FKAS: {
      return "https://minside.fjordkraft.no/tjenester/forutsigbar"
    }
    case BrandEnum.TKAS:{
      return "https://minside.trondelagkraft.no/tjenester/forutsigbar"
    }
    default: {
      return "https://steddi.no"
    }
  }
}